import { InputNumber, Slider } from 'antd';
import { ParameterLimitsValues } from '../types';

type ParameterLimitsProps = {
  customValues: ParameterLimitsValues;
  calculateLiao: (newCustomValues: Partial<ParameterLimitsValues>) => Promise<void> 
  disabled: boolean;
};

export function ParameterLimits({
  customValues,
  calculateLiao,
  disabled
}: ParameterLimitsProps) {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around'
        }}
      >
        <h5 style={{ marginBottom: '2rem' }}>Parameter Limits</h5>
        <div>
          <h6>A</h6>
          <Slider
            value={customValues.a}
            onChange={value => calculateLiao({ a: value })}
            min={0.000001}
            max={1}
            step={0.001}
            disabled={disabled}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <span>Value: </span>
            <InputNumber
              value={customValues.a}
              step={0.001}
              onChange={value => {
                if (value != null) calculateLiao({ a: value });
              }}
              style={{ width: '8rem' }}
              disabled={disabled}
            />
          </div>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <h6>B</h6>
          <Slider
            value={customValues.b}
            onChange={value => calculateLiao({ b: value })}
            min={1}
            max={1000}
            step={0.001}
            disabled={disabled}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <span>Value: </span>
            <InputNumber
              value={customValues.b}
              onChange={value => {
                if (value != null) calculateLiao({ b: value });
              }}
              style={{ width: '8rem' }}
              disabled={disabled}
              step={0.001}
            />
          </div>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <h6>Pce</h6>
          <Slider
            value={customValues.pce}
            onChange={value => calculateLiao({ pce: value })}
            min={0.00001}
            max={1}
            step={0.00001}
            disabled={disabled}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <span>Value: </span>
            <InputNumber
              value={customValues.pce}
              onChange={value => {
                if (value != null) calculateLiao({ pce: value });
              }}
              style={{ width: '8rem' }}
              disabled={disabled}
              step={0.001}
            />
          </div>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px'
            }}
          >
            <span style={{ fontSize: '16px' }}>Large derivative:</span>
            <InputNumber
              value={customValues.largeDerivative}
              onChange={value => {
                if (value != null) calculateLiao({ largeDerivative: value });
              }}
              style={{ width: '8rem' }}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
